// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18e02b15","554":"e8cfb099"}[chunkId] + ".chunk.js";
};